const payLaterAvailability = {
  '/docs/checkout/pay-later/': ['AU', 'DE', 'ES', 'FR', 'GB', 'IT', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/adyen/': [
    'FR',
    'GB',
    'US',
    'AU',
  ],
  '/docs/checkout/pay-later/commerce-platforms/angelleye/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/bigcommerce/': [
    'AU',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/bluepark/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/centarro/': ['US'],
  '/docs/checkout/pay-later/commerce-platforms/commerce-vision/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/create/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/cubecart/': ['FR', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/ekm/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/freewebstore/': ['FR', 'GB'],
  '/docs/checkout/pay-later/commerce-platforms/genecommerce/': ['GB', 'IT'],
  '/docs/checkout/pay-later/commerce-platforms/jotform/': ['US'],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/genecommerce/': [
    'AU',
    'ES',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/iwd/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/magento-braintree/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/magento-paypal/': [
    'FR',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/paypal/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/mals/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/miva/': ['FR', 'GB', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/opencart/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/oscomerce/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/pinnaclecart/': ['GB', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/prestashop/': ['FR', 'AU'],
  '/docs/checkout/pay-later/commerce-platforms/romancart/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/salesforce/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/salesforce/braintree/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/salesforce/paypal/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/sap/': ['AU', 'FR'],
  '/docs/checkout/pay-later/commerce-platforms/sap/braintree/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/sap/paypal/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/sellr/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/shift4shop/': ['GB', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/solidus/': ['US'],
  '/docs/checkout/pay-later/commerce-platforms/ueni/': ['GB', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/viva-wallet/': ['ES', 'FR'],
  '/docs/checkout/pay-later/commerce-platforms/vortx/': ['GB', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/woocommerce/': [
    'AU',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/woocommerce/braintree/': [
    'AU',
    'FR',
  ],
  '/docs/checkout/pay-later/commerce-platforms/woocommerce/braintree/reference/':
    ['AU', 'FR'],
  '/docs/checkout/pay-later/commerce-platforms/woocommerce/paypal/': [
    'AU',
    'FR',
  ],
  '/docs/checkout/pay-later/commerce-platforms/x-cart/': ['AU', 'US'],
  '/docs/checkout/pay-later/integrate/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/integrate/advanced-js-options/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/integrate/analytics/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/integrate/code-samples/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/integrate/customize-messages/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
}

export { payLaterAvailability }
